import {
  Users,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Clock,
  AlertOctagon,
  Network,
} from "lucide-react";
import { formatNumber } from "../../../utils/interface";

interface TrafficData {
  total_sent: number;
  total_delivered: number;
  total_pending: number;
  total_failed: number;
  total_absent_from_network: number;
  invalid: number;
  total_delivered_to_network: number;
  report_date: string;
}

const Stats = () => {
  // Traffic data from the report
  const trafficData: TrafficData = {
    total_sent: 15040,
    total_delivered: 5040,
    total_pending: 101405,
    total_failed: 11154,
    total_absent_from_network: 7448,
    invalid: 5,
    total_delivered_to_network: 4000,
    report_date: "2025-05-22",
  };


  return (
    <section>
      <div className="grid grid-cols-1 gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-4">
        <div className="overflow-hidden bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="bg-red-100 p-2 rounded-lg">
                <Users className="h-5 w-5 text-red-600" />
              </div>
              <div className="bg-gray-100 px-2 py-1 rounded-full text-xs font-medium text-gray-600">
                Total
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">
                Total Sent
              </p>
              <div className="flex items-end">
                <p className="text-2xl font-bold text-gray-900">
                  {formatNumber(trafficData.total_sent)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-hidden bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="bg-green-100 p-2 rounded-lg">
                <CheckCircle className="h-5 w-5 text-green-600" />
              </div>
              <div className="bg-green-100 px-2 py-1 rounded-full text-xs font-medium text-green-600">
                Delivered
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">
                Delivered
              </p>
              <div className="flex items-end">
                <p className="text-2xl font-bold text-green-600">
                  {formatNumber(trafficData.total_delivered)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-hidden bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="bg-blue-100 p-2 rounded-lg">
                <Clock className="h-5 w-5 text-blue-600" />
              </div>
              <div className="bg-blue-100 px-2 py-1 rounded-full text-xs font-medium text-blue-600">
                Pending
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">Pending</p>
              <div className="flex items-end">
                <p className="text-2xl font-bold text-blue-600">
                  {formatNumber(trafficData.total_pending)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-hidden bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="bg-red-100 p-2 rounded-lg">
                <XCircle className="h-5 w-5 text-red-600" />
              </div>
              <div className="bg-red-100 px-2 py-1 rounded-full text-xs font-medium text-red-600">
                Failed
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">Failed</p>
              <div className="flex items-end">
                <p className="text-2xl font-bold text-red-600">
                  {formatNumber(trafficData.total_failed)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-hidden bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="bg-amber-100 p-2 rounded-lg">
                <AlertTriangle className="h-5 w-5 text-amber-600" />
              </div>
              <div className="bg-amber-100 px-2 py-1 rounded-full text-xs font-medium text-amber-600">
                Absent
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">
                Absent From Network
              </p>
              <div className="flex items-end">
                <p className="text-2xl font-bold text-amber-600">
                  {formatNumber(trafficData.total_absent_from_network)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-hidden bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="bg-purple-100 p-2 rounded-lg">
                <AlertOctagon className="h-5 w-5 text-purple-600" />
              </div>
              <div className="bg-purple-100 px-2 py-1 rounded-full text-xs font-medium text-purple-600">
                Invalid
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">Invalid</p>
              <div className="flex items-end">
                <p className="text-2xl font-bold text-purple-600">
                  {formatNumber(trafficData.invalid)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-hidden bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="bg-teal-100 p-2 rounded-lg">
                <Network className="h-5 w-5 text-teal-600" />
              </div>
              <div className="bg-teal-100 px-2 py-1 rounded-full text-xs font-medium text-teal-600">
                Network
              </div>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500 mb-1">
                Delivered To Network
              </p>
              <div className="flex items-end">
                <p className="text-2xl font-bold text-teal-600">
                  {formatNumber(trafficData.total_delivered_to_network)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
